{
  "level": "jctmov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:jctmov",
    "objects": "AREAS.E3:jctmov.e3",
    "mesh": "TREES.E3:jctmov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: elevjct2",
      "entity_class": "CSlidingDoor",
      "piece_name": "elevjct2",
      "offset": 431,
      "centroid": [
        -2513.807861328125,
        -4050.25,
        1100.8499755859375
      ],
      "bbox_min": [
        -2518.815673828125,
        -4056.199951171875,
        1100.5999755859375
      ],
      "bbox_max": [
        -2508.800048828125,
        -4044.300048828125,
        1101.0999755859375
      ],
      "dimensions_source": {
        "span_x": 10.015625,
        "span_y": 11.89990234375,
        "height_z": 0.5,
        "door_width": 11.89990234375,
        "door_depth": 10.015625,
        "leaf_depth": 9.975625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0013,
          0.0
        ]
      },
      "vertices": [
        [
          -2508.815673828125,
          -4044.300048828125,
          1100.5999755859375
        ],
        [
          -2518.815673828125,
          -4044.300048828125,
          1100.5999755859375
        ],
        [
          -2518.800048828125,
          -4056.199951171875,
          1100.5999755859375
        ],
        [
          -2508.800048828125,
          -4056.199951171875,
          1100.5999755859375
        ],
        [
          -2508.815673828125,
          -4044.300048828125,
          1101.0999755859375
        ],
        [
          -2518.815673828125,
          -4044.300048828125,
          1101.0999755859375
        ],
        [
          -2518.800048828125,
          -4056.199951171875,
          1101.0999755859375
        ],
        [
          -2508.800048828125,
          -4056.199951171875,
          1101.0999755859375
        ]
      ],
      "plane_distance": 2514.124,
      "authentic_texture": "basewalllight1"
    },
    {
      "tag": "CSlidingDoor piece: platjct1",
      "entity_class": "CSlidingDoor",
      "piece_name": "platjct1",
      "offset": 3393,
      "centroid": [
        -2420.5,
        -3981.200048828125,
        1033.8
      ],
      "bbox_min": [
        -2423.300048828125,
        -3985.800048828125,
        1032.0
      ],
      "bbox_max": [
        -2417.699951171875,
        -3979.800048828125,
        1038.0
      ],
      "dimensions_source": {
        "span_x": 5.60009765625,
        "span_y": 6.0,
        "height_z": 6.0,
        "door_width": 6.0,
        "door_depth": 5.60009765625,
        "leaf_depth": 5.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2423.300048828125,
          -3979.800048828125,
          1032.0
        ],
        [
          -2417.699951171875,
          -3979.800048828125,
          1032.0
        ],
        [
          -2417.699951171875,
          -3985.800048828125,
          1032.0
        ],
        [
          -2423.300048828125,
          -3985.800048828125,
          1032.0
        ],
        [
          -2423.300048828125,
          -3979.800048828125,
          1032.5
        ],
        [
          -2417.699951171875,
          -3979.800048828125,
          1032.5
        ],
        [
          -2417.699951171875,
          -3985.800048828125,
          1032.5
        ],
        [
          -2423.300048828125,
          -3985.800048828125,
          1032.5
        ],
        [
          -2422.0,
          -3979.800048828125,
          1032.5
        ],
        [
          -2422.0,
          -3979.800048828125,
          1032.5
        ],
        [
          -2419.0,
          -3979.800048828125,
          1038.0
        ],
        [
          -2419.0,
          -3979.800048828125,
          1038.0
        ],
        [
          -2419.0,
          -3979.800048828125,
          1032.5
        ],
        [
          -2419.0,
          -3979.800048828125,
          1032.5
        ],
        [
          -2422.0,
          -3979.800048828125,
          1038.0
        ],
        [
          -2422.0,
          -3979.800048828125,
          1038.0
        ],
        [
          -2422.0,
          -3980.800048828125,
          1032.5
        ],
        [
          -2422.0,
          -3980.800048828125,
          1035.5
        ],
        [
          -2419.0,
          -3980.800048828125,
          1035.5
        ],
        [
          -2419.0,
          -3980.800048828125,
          1032.5
        ]
      ],
      "plane_distance": -2422.0,
      "authentic_texture": "cbaseelevpanelup"
    },
    {
      "tag": "CSlidingDoor piece: platjct3",
      "entity_class": "CSlidingDoor",
      "piece_name": "platjct3",
      "offset": 5545,
      "centroid": [
        -2511.93994140625,
        -4031.200048828125,
        1033.8
      ],
      "bbox_min": [
        -2514.800048828125,
        -4035.800048828125,
        1032.0
      ],
      "bbox_max": [
        -2509.199951171875,
        -4029.800048828125,
        1038.0
      ],
      "dimensions_source": {
        "span_x": 5.60009765625,
        "span_y": 6.0,
        "height_z": 6.0,
        "door_width": 6.0,
        "door_depth": 5.60009765625,
        "leaf_depth": 5.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2514.800048828125,
          -4029.800048828125,
          1032.0
        ],
        [
          -2509.199951171875,
          -4029.800048828125,
          1032.0
        ],
        [
          -2509.199951171875,
          -4035.800048828125,
          1032.0
        ],
        [
          -2514.800048828125,
          -4035.800048828125,
          1032.0
        ],
        [
          -2514.800048828125,
          -4029.800048828125,
          1032.5
        ],
        [
          -2509.199951171875,
          -4029.800048828125,
          1032.5
        ],
        [
          -2509.199951171875,
          -4035.800048828125,
          1032.5
        ],
        [
          -2514.800048828125,
          -4035.800048828125,
          1032.5
        ],
        [
          -2513.39990234375,
          -4029.800048828125,
          1032.5
        ],
        [
          -2513.39990234375,
          -4029.800048828125,
          1032.5
        ],
        [
          -2510.39990234375,
          -4029.800048828125,
          1038.0
        ],
        [
          -2510.39990234375,
          -4029.800048828125,
          1038.0
        ],
        [
          -2510.39990234375,
          -4029.800048828125,
          1032.5
        ],
        [
          -2510.39990234375,
          -4029.800048828125,
          1032.5
        ],
        [
          -2513.39990234375,
          -4029.800048828125,
          1038.0
        ],
        [
          -2513.39990234375,
          -4029.800048828125,
          1038.0
        ],
        [
          -2513.39990234375,
          -4030.800048828125,
          1032.5
        ],
        [
          -2513.39990234375,
          -4030.800048828125,
          1035.5
        ],
        [
          -2510.39990234375,
          -4030.800048828125,
          1035.5
        ],
        [
          -2510.39990234375,
          -4030.800048828125,
          1032.5
        ]
      ],
      "plane_distance": -2513.3999,
      "authentic_texture": "cbaseelevpanelup"
    }
  ],
  "tutorial_messages": []
}